import { Component, OnInit } from '@angular/core';
import { AddLogoComponent } from './add-logo/add-logo.component';
import { MatDialog } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/data.service';
import { AuthService } from 'src/app/auth/auth.service';
import { User } from 'src/app/auth/user.model';
import { UtilsService } from 'src/app/shared/utils.service';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { LogosCompany } from "../../shared/logos-company.model";
import {PageEvent} from "@angular/material/paginator";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {ConfirmDialogComponent} from "../../shared/confirm-dialog/confirm-dialog.component";

@Component({
    selector: 'app-logos-company',
    templateUrl: './logos-company.component.html',
    styleUrls: ['./logos-company.component.scss'],
    standalone: false
})
export class LogosCompanyComponent implements OnInit {
  userID: number;
  userData: User;
  newImage: any;
  logosList = new Array<any>();
  totalSize = 0;
  pageEvent!: PageEvent;
  pageSize = 10;
  pageNumber = 1;
  queryParams: {
    pageNumber: number;
    pageSize: number;
  } = {
    pageNumber: 0,
    pageSize: 0,
  };

  constructor(public dialog: MatDialog, private dataService: DataService,
              private authService: AuthService, private router: Router,
              public utils: UtilsService,
              private route: ActivatedRoute
              ) {
                this.newImage = null;
                this.userData = this.authService.getUserData();
                this.userID = this.userData.id;

                this.route.queryParams.subscribe((params: Params) => {
                  if (!this.isEmpty(params)) {
                    this.pageNumber = params.pageNumber ? params.pageNumber : 1;
                    this.pageSize = params.pageSize ? params.pageSize : 10;
                  }
                  this.getData();
                });
              }

  isEmpty(obj: any) {
    return Object.keys(obj).length === 0;
  }

  ngOnInit(): void {
    this.utils.setTitle('Logos Company');
    this.utils.screenTitle.emit({firstTitle: 'Logos', firstRoute: '/logos'});
  }

  getData() {
    this.dataService.get('logos/RetrieveAllCompanies?pageNumber=' + this.pageNumber +
    '&pageSize=' + this.pageSize).then((data: any) => {
      if (data.statusCode === 200) {
        this.logosList = [];
        const logosData = data.data.records;
        this.totalSize = data.data.count;
        logosData.forEach((logoData: any) => {
          const logoInstance = new LogosCompany(logoData);
          this.logosList.push(logoInstance);
        });
        if (logosData.length === 0 && this.totalSize > 0) {
          this.pageNumber = 1;
          this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize};
          this.router.navigate(['/logos'], { queryParams: this.queryParams });
        }
      }
    });
  }

  openAddLogo() {
    const dialogRef = this.dialog.open(AddLogoComponent, {disableClose: true, width: '500px'});
    dialogRef.afterClosed().subscribe((status) => {
      this.getData();
    });
  }

  handlePage(e: any) {
    this.pageNumber = e.pageIndex + 1;
    this.pageSize = e.pageSize;
    this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize};
    this.router.navigate(['/logos'], { queryParams: this.queryParams });
  }

  deleteLogo(id: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '400px',
      data: {
        title: 'Delete',
        page: 'logo',
      }
    });
    dialogRef.afterClosed().subscribe((status) => {
      if (status) {
        if (status === 'accept') {
          this.dataService.delete('logos/delete/' + id).then((data: any) => {
            if (data.statusCode === 200) {
              this.logosList.forEach( (logos, index) => {
                if (logos.id === id) {
                  this.logosList.splice(index, 1);
                  if (this.logosList.length === 0 && this.pageNumber > 1) {
                    this.pageNumber = this.pageNumber - 1;
                    this.router.navigate(['/logos'], );
                  } else {
                    this.ngOnInit();
                  }
                }
              });
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Success',
                  type: 'Success',
                  message: 'Logo deleted successfully',
                  buttonText: 'Ok'
                }
              });
            } else {
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Error',
                  type: 'Error',
                  message: 'Something went wrong, Please try again!',
                  buttonText: 'Ok'
                }
              });
            }
          });
        }
      }
    });
  }
}
